import React from "react";
import { withStyles } from "@material-ui/styles";

import Grid from "@material-ui/core/Grid";

import images from "../../../assets/img/images";

const styles = {
  separator: {
    margin: "0px 10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

const BreadcrumbSeparator = (props) => {
  const { classes } = props;

  return (
    <Grid item className={classes.separator}>
      <img src={images.breadcrumbIcon} height="12px" alt=">" />
    </Grid>
  );
};

export default withStyles(styles)(BreadcrumbSeparator);
